// This file is autogenerated. Any changes will be overwritten.
export const name = 'minus';

export const Component = () => (
  <path d='M6.00546875,11 C6.00546875,11 19.703125,11 19.703125,11 C20.3734375,11 20.7085937,11.3351563 20.7085937,11.9578125 C20.7085937,12.5804687 20.3734375,12.915625 19.703125,12.915625 C19.703125,12.915625 19.703125,12.915625 19.703125,12.915625 C19.703125,12.915625 6.00546875,12.915625 6.00546875,12.915625 C5.33515625,12.915625 5,12.5804687 5,11.9578125 C5,11.3351562 5.33515625,11 6.00546875,11 C6.00546875,11 6.00546875,11 6.00546875,11 Z' />
);

export const viewBox = '0 0 25 25';
